import styled from 'styled-components';
import { device } from '@util/commonMediaStylesUtil';

// Quarterly Details
export const ContainerWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 30px;
  width: 100%;
  max-width: 100%;
`;

export const QuarterDetailsContainer = styled.div`
  width: 100%;
  max-width: calc(50% - 15px);
  background-color: #ffffff;
  border: 1px solid #c4c4cd;
  stroke-alignment: outside;
  border-weight: 1;

  ${device.laptop_md`
    max-width: 100%;
 `}
`;

export const MonthlyTitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0px;
  text-align: left;
  color: #2e2e38;
  padding-bottom: 20px;
  border-top: 1px solid #c4c4cd;
  height: 74px;
`;

export const TitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 35px;
  gap: 10px;
  align-items: center;
  width: 100%;
`;

export const CommonTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 35px;
  gap: 6px;
  align-items: center;
  width: 100%;
  padding-top: 14px;
`;

export const SubHeaderContainer = styled.div`
  justify-content: space-between;
  padding: 15px 20px;
  border: 0px 0px 1px 0px;
  gap: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  justify-content: end;
`;

export const CommonSubHeaderContainer = styled.div`
  padding: 14px 20px;
  border: 0px 0px 1px 0px;
  gap: 10px;
  height: auto;
  flex: auto;
`;

export const QuarterHeader = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  justify-content: end;
`;

export const DropDownSubHeaderContainer = styled.div`
  justify-content: space-between;
  padding: 0px 10px;
  border: 0px 0px 1px 0px;
  gap: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  justify-content: end;
  margin-top: 15px;
`;

export const DropDownButtonSubHeaderContainer = styled.div`
  justify-content: space-between;
  padding: 0px 10px 15px 0px;
  border: 0px 0px 1px 0px;
  gap: 10px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: auto;
  justify-content: end;
  margin-top: 15px;
`;

export const StyledHeader = styled.h3`
  font-family: EYInterstate;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  color: #000000;
  white-space: nowrap;
`;

export const RowStyle = styled.div`
  color: #000000;
  font-family: 'EYInterstate Regular';
  font-size: 22px;
  line-height: 22px;
  text-align: end;
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const DropdownContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 5px;
  width: 100%;
`;

export const ViewForecastQuarterButton = styled.div`
  text-align: center;
  align-items: flex-end;
`;

// MonthlySidebarStyles.js
export const MonthlyBar = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #f6f6fa;
`;

export const CommonMonthlyBar = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 10px;
  background-color: #f6f6fa;
  height: 42.4%;

  ${device.phone_l`
  grid-template: none;
`}
`;

export const MonthlyBarStyle = styled.div`
  // display: flex;
  // flex-direction: column;
  ${device.phone_l`
  display: flex;
  justify-content: space-between;`}
`;

export const SidebarStyle = styled.div`
  padding-left: 10px;
  padding-right: 10px;
  margin-bottom: 10px;
  display: grid;
  grid-template-columns: 1fr 4fr 1fr;
  gap: 10px;
  align-items: center;

  ${device.phone_l`
    margin-bottom: 0px;
  `}
`;

export const MonthlyDetailsContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10px;

  ${device.laptop_sm`
    padding: 0 10px;
    gap: 7px;
  `}

  ${device.phone_sm`
    padding: 0px;
    gap: 0px;
  `}
`;

export const ColumnStyle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-end;
  color: #2e2e38;
  font-family: 'EYInterstate Regular';
  font-size: 14px;
  padding: 5px;
`;

export const CommonColumnStyle = styled.div`
  height: 50px;
  color: #2e2e38;
  font-family: 'EYInterstate Regular';
`;

export const ColumnOneStyle = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: #ffffff;
  font-family: 'EYInterstate Regular';
  font-size: 14px;
  padding: 5px;
`;

export const MonthTextContainer = styled.div`
  display: flex;
  align-items: center;
  width: 105px;
`;

export const MonthText = styled.p`
  color: #155cb4;
  font-family: 'EYInterstate';
  width: 30px;
  font-weight: 700;
`;

export const SoldTextStyle = styled.span`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 300;
  color: #2e2e38;

  ${device.laptop_xl`
  white-space: nowrap;
  `}
`;

export const ValueStyle = styled.span`
  font-family: 'EYInterstate';
  font-size: 14px;
  font-weight: 600;
  color: #2e2e38;
`;

export const Separator = styled.div`
  height: 1px;
  background-color: #e7e7ea;
  margin: 10px 15px;
`;

export const MonthlyContainer = styled.div`
  border: 'opx solid #f6f6fa';
`;

export const CommonSeparator = styled.div`
  height: 1px;
`;

export const CommonMonthlyContainer = styled.div`
  width: auto;
  padding: 0px 15px 15px 15px;
  border-right: 1px solid #e0e0e0;
  margin-bottom: 15px;
  &:last-child {
    border-right: none;
  }
`;

export const MissedText = styled.span`
  color: #ba281f;
  font-family: 'EYInterstate';
  font-size: 14px;
`;

export const ForecastAccuracy = styled.div`
  margin-right: 5px;
`;

export const buttonStyle = {
  cursor: 'pointer',
  width: '100%',
  height: 44,
  fontWeight: 400,
};
export const disableViewButtonStyle = {
  width: '100%',
  height: 20,
  fontWeight: 400,
  padding: '22px 0px',
};
export const buttonStyleForecast = {
  cursor: 'pointer',
  width: '100%',
  height: 44,
  fontWeight: 400,
};
export const buttonStyleForecastPL = {
  cursor: 'pointer',
  width: '100%',
  height: 44,
  fontWeight: 400,
  marginTop: 68,
};
export const buttonStyleForecastGCSP = {
  cursor: 'pointer',
  width: '100%',
  height: 44,
  fontWeight: 400,
  marginTop: 38,
};
export const buttonStyleForecastMSL = {
  cursor: 'pointer',
  width: '100%',
  height: 44,
  fontWeight: 400,
  marginTop: 36,
};

export const mobileBtnStyle = {
  width: '20%',
  height: '30px',
};

export const Month = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #155cb4;
  margin-bottom: 16px;
`;

export const Item = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 8px;
  ${device.phone_l`
  flex-direction: column;
  `}
`;

export const Label = styled.span`
  font-size: 14px;
  color: #333;
`;

export const Value = styled.span`
  font-size: 14px;
  color: #333;
  font-weight: 400;
  white-space: nowrap;
`;

export const PillContainer = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const PillStyle = styled.div`
  padding-top: 4;
  padding-bottom: 15;
`;

export const MslSubHeaderContainer = styled.div`
  padding: 14px 20px;
  border: 0px 0px 1px 0px;
  gap: 10px;
  height: auto;
  flex: auto;
`;

export const MslTitleContainer = styled.div`
  display: flex;
  flex-direction: row;
  height: 35px;
  gap: 6px;
  align-items: center;
  width: 100%;
  padding-top: 14px;
`;

export const MonthBtnStyle = styled.div`
  display: flex;
  justify-content: space-between;
`;

// MSL Future Period Specific Styles for PL Projected Forecast + Audit/TR
export const ItemMSLFuture = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 8px;
  ${device.phone_l`
    flex-direction: column;
  `}
`;

export const LabelMSLFuture = styled.span`
  font-size: 14px;
  color: #333;
  flex: 1;
  margin-right: 8px;
  line-height: 1.2;
`;

export const ValueMSLFuture = styled.span`
  font-size: 14px;
  color: #333;
  font-weight: 400;
  flex-shrink: 0;
  white-space: nowrap;
`;
